import { FC, useMemo } from 'react';
import { useErrorPanelStore, selectErrorsByScope } from '@stores';
import ErrorPanel from './ErrorPanel';
import styles from './ErrorPanelContainer.module.css';

const ErrorPanelContainer: FC = () => {
    const errorsByScope = useErrorPanelStore(selectErrorsByScope);
    const entries = useMemo(
        () => Object.values(errorsByScope).flat(),
        [errorsByScope],
    );

    if (entries.length === 0) {
        return null;
    }

    return (
        <div className={styles.errorPanelContainer}>
            <ErrorPanel entries={entries} />
        </div>
    );
};

export default ErrorPanelContainer;
